import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AnotacionAdminNacionalEntry } from 'src/app/shared/entrys/anotacion-admin-nacional.entry';
import { CamaraComercioEntry } from 'src/app/shared/entrys/camara-comercio';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType, TipoConfirmacionModalType } from 'src/app/shared/models/confirmar-respuesta.model';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { AdministradorAnotacionesService } from './administrador-anotaciones.service';
import { AlertType } from 'src/app/shared/models/alert.model';
import { AlertsService } from 'src/app/shared/services/alerts.service';

@Component({
  selector: 'app-anotaciones',
  templateUrl: './anotaciones.component.html',
  styleUrls: ['./anotaciones.component.scss']
})
export class AnotacionesAdminComponent implements OnInit {

	public headers: string[] = [];
	public dataTabla: DatoPaginadoModel;
	public paginaActual: number = 1;
	public formFiltroSolicitud: FormGroup;
	public camarasLista: Array<CamaraComercioEntry>;
	public anotaciones: Array<AnotacionAdminNacionalEntry>;

	constructor(
		private formBuilder: FormBuilder, 
		private _administradorAnotacionesService: AdministradorAnotacionesService,
		private _modalService: NgbModal,
		private _alertService:AlertsService) 
	{
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;
	}

	ngOnInit() {
		this.headers = ['SOLICITUD_ID', 'Fecha de creación', 'Número de radicado',
			'Tipo de solicitud', 'Tipo de anotación', 'Descripción', 'Usuario de creacion',
			'Activo', ''];

		this.getCamarasDeComercio();
		
		this.formFiltroSolicitud = this.createFormFiltroAnotaciones();
		// this.onFiltrar();
	}

	private createFormFiltroAnotaciones(): FormGroup {
		return this.formBuilder.group({
			codigo_camara: [undefined],
			codigo_rnt: [undefined],
			numero_radicado: [undefined]
		})
	}
	private getCamarasDeComercio(): void {
		this._administradorAnotacionesService.getCamarasDeComercio()
			.subscribe(resultado => {
				if (!resultado) return;
				this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
			});
	}

	public onFiltrar() {
		let puedeFiltrar:boolean = true;
		const requestConsulta = this.formFiltroSolicitud.value,
		codigo_camara = requestConsulta.codigo_camara?.trim(),
		numero_radicado = requestConsulta.numero_radicado?.trim(),
		codigo_rnt = requestConsulta.codigo_rnt?.trim();

		if(codigo_camara && !numero_radicado){
			puedeFiltrar = false;
			this.abrirModalDeInformacion(`Debe digitar el número de radicado junto con 
				la cámara de comercio para poder realizar la busqueda`);
		}
		if (!codigo_camara && numero_radicado) {
			puedeFiltrar = false;
			this.abrirModalDeInformacion(`Debe digitar la cámara de comercio junto con 
				el número de radicado para poder realizar la busqueda`);
		}
		if (!codigo_camara && !numero_radicado && !codigo_rnt){
			puedeFiltrar = false;
			this.abrirModalDeInformacion(`Debe utilizar por lo menos un filtro de busqueda para 
			realizar esta operación`);
		}
		if(!puedeFiltrar) return;
		this.onPaginado(1);
	}

	public onPaginado(value: number) {
		this.paginaActual = value;
		this._administradorAnotacionesService.getAnotaciones(value, this.formFiltroSolicitud.value)
		.subscribe(resultado => {
			if (!resultado.result) return;
			this.dataTabla = resultado.data as DatoPaginadoModel;
			this.anotaciones = this.dataTabla.items as Array<AnotacionAdminNacionalEntry>;
		});
	}

	public reset() {
		this.formFiltroSolicitud.reset();
		this.dataTabla = this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;
		this.anotaciones = [];
		// this.onFiltrar();
	}

	private abrirModalDeInformacion(mensaje:string):void {
		let data: ConfirmarRespuestaModel = {
			imagen: '',
			type: ConfirmarRespuestaType.Atencion,
			tipoConfirmacionModalType: TipoConfirmacionModalType.Alerta,
			buttonTextAlert: 'Aceptar',
			message: mensaje
		};
		
		const modal = this._modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
		modal.componentInstance.confirmarRespuesta = data;
	}

	public activarInactivarAnotacion(anotacion:AnotacionAdminNacionalEntry): void {
		this._administradorAnotacionesService.update(anotacion)
		.subscribe(response => {
			if (!response.result) return; 
			this._alertService.alert(response.control.alert_type as AlertType, 
				response.control.message, window.location.pathname, `${response.control.code}`);
		})
	}
}